/*
 * Per-line order note — click-to-edit + autosave in the cart drawer
 * -----------------------------------------------------------------------------
 * Each cart line has an "Add a note" / "Edit note" toggle (snippets/cart-items.liquid,
 * gated by settings.cart_line_note). Clicking it opens a textarea; the note
 * AUTOSAVES — there is no Save button. It persists ~0.7s after typing stops, on
 * blur, and is flushed when the drawer closes.
 *
 * Saving writes to the line's line-item property (default "Order Notes") via
 * /cart/change.js addressed by LINE NUMBER (stable across edits). We always send
 * the line's FULL property set with only the note changed, so other properties
 * (a flavor "Selected Jar", hidden app props like _Zapietid) are never lost.
 * An empty note is saved as "" which Shopify drops, removing the property.
 *
 * The display (preview + toggle label) is updated in place, so no drawer re-render
 * is needed while editing.
 */
(function () {
  var routes = (window.Shopify && window.Shopify.routes) || {};
  var CHANGE_URL = (routes.cart_change_url || '/cart/change') + '.js';

  function reflect(box, val) {
    var hasVal = !!(val && val.trim() !== '');
    var label = box.querySelector('[data-cart-line-note-label]');
    var preview = box.querySelector('[data-cart-line-note-preview]');
    var valueEl = box.querySelector('[data-cart-line-note-value]');
    if (valueEl) valueEl.textContent = val || '';        // keeps the "Note:" prefix intact
    if (preview) preview.hidden = !hasVal || !!box._open; // hide while the editor is open
    if (label) {
      label.textContent = hasVal
        ? (box.getAttribute('data-text-edit') || 'Edit note')
        : (box.getAttribute('data-text-add') || 'Add a note');
    }
  }

  function flashSaved(box) {
    var status = box.querySelector('[data-cart-line-note-status]');
    if (!status) return;
    status.textContent = box.getAttribute('data-text-saved') || 'Saved';
    status.hidden = false;
    clearTimeout(box._statusT);
    box._statusT = setTimeout(function () { status.hidden = true; }, 1600);
  }

  function saveBox(box, opts) {
    opts = opts || {};
    var field = box.querySelector('[data-cart-line-note-field]');
    var line = parseInt(box.getAttribute('data-line-index'), 10);
    var prop = box.getAttribute('data-note-prop');
    if (!field || !line || !prop) return;

    var val = field.value == null ? '' : field.value;
    if (box._lastNote === val && !opts.force) return; // unchanged
    box._lastNote = val;

    var existing = {};
    try { existing = JSON.parse(box.getAttribute('data-line-properties') || '{}'); } catch (e) {}
    if (!existing || typeof existing !== 'object' || Array.isArray(existing)) existing = {};

    var props = {};
    Object.keys(existing).forEach(function (k) { props[k] = existing[k]; });
    props[prop] = (val.trim() !== '') ? val : '';

    var body = JSON.stringify({ line: line, properties: props });

    if (opts.beacon && navigator.sendBeacon) {
      try { navigator.sendBeacon(CHANGE_URL, new Blob([body], { type: 'application/json' })); }
      catch (e) { /* ignore */ }
    } else {
      fetch(CHANGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body,
        keepalive: true
      }).then(function () { flashSaved(box); }).catch(function () {});
    }

    reflect(box, val); // keep display in sync without a re-render
  }

  function openEditor(box) {
    var editor = box.querySelector('[data-cart-line-note-editor]');
    var preview = box.querySelector('[data-cart-line-note-preview]');
    var field = box.querySelector('[data-cart-line-note-field]');
    if (editor) editor.hidden = false;
    if (preview) preview.hidden = true;
    box._open = true;
    if (field) {
      box._lastNote = field.value; // baseline: only save if it actually changes
      field.focus();
      try { field.setSelectionRange(field.value.length, field.value.length); } catch (e) {}
    }
  }

  function closeEditor(box) {
    clearTimeout(box._t);
    saveBox(box);
    var editor = box.querySelector('[data-cart-line-note-editor]');
    if (editor) editor.hidden = true;
    box._open = false;
    var field = box.querySelector('[data-cart-line-note-field]');
    reflect(box, field ? field.value : '');
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cart-line-note-toggle]');
    if (!t) return;
    e.preventDefault();
    var box = t.closest('[data-cart-line-note]');
    if (!box) return;
    if (box._open) closeEditor(box); else openEditor(box);
  });

  document.addEventListener('input', function (e) {
    var field = e.target;
    if (!field.matches || !field.matches('[data-cart-line-note-field]')) return;
    var box = field.closest('[data-cart-line-note]');
    if (!box) return;
    box._touched = true;
    clearTimeout(box._t);
    box._t = setTimeout(function () { saveBox(box); }, 700);
  });

  document.addEventListener('blur', function (e) {
    var field = e.target;
    if (!field.matches || !field.matches('[data-cart-line-note-field]')) return;
    var box = field.closest('[data-cart-line-note]');
    if (!box) return;
    clearTimeout(box._t);
    saveBox(box);
  }, true);

  // Flush any dirty note when the drawer closes without a blur/close.
  document.addEventListener('hide.bs.offcanvas', function (e) {
    if (!e.target || e.target.id !== 'offcanvas-cart') return;
    document.querySelectorAll('[data-cart-line-note]').forEach(function (box) {
      var field = box.querySelector('[data-cart-line-note-field]');
      if (field && box._touched && box._lastNote !== field.value) {
        clearTimeout(box._t);
        saveBox(box, { beacon: true });
      }
    });
  });
})();
